import { PostModel } from '@libs/gc-common/lib/api/models/post';
import { StoryInterface } from './story.interface';

export class StoryModel extends PostModel {
  
  type = 'story';
  
  constructor(model?: StoryInterface) {
    super(model);
    this.fill(model);
  }
  
}
